import gql from 'graphql-tag';

export const GET_COUNTS_BY_TASK_IDS_QUERY = gql`
  query GetCountsByTaskIdsQuery($projectId: Int!, $taskIds: [String!]!) {
    counts: getCountsByTaskIds(projectId: $projectId, taskIds: $taskIds)
  }
`;
